var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tree-node',{attrs:{"active-name":_vm.activeName,"tree-node":_vm.treeObject},on:{"selected":_vm.select}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }